export default __webpack_public_path__ + "static/media/twitter.8c975cce.svg";